<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__header signing-room-dialog-header">
    <h3 class="modal-title" data-testid="signing-room-dialog-title">{{ dialogTitle() }}</h3>
  </div>
  <div class="generic-confirm-modal__body">
    <p data-testid="signing-room-dialog-message">
      {{ message() }}
    </p>
  </div>
  <div class="generic-confirm-modal__footer">
    <ng-content></ng-content>
  </div>
</div>
